// extracted by mini-css-extract-plugin
export default {"button":"button_button__2QaKZ","transparent":"button_transparent__xTN2w","reverse":"button_reverse__ubuV8"};